import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/button';
import {getIntroCardImageSrc} from 'common/utils/statics-util';
import {t} from 'common/utils/translation-util';

export default class ZeroCard extends React.Component {
  static propTypes = {
    href: PropTypes.string,
    isHomepage: PropTypes.bool,
  };

  static defaultProps = {
    href: '#',
    isHomepage: false,
  };

  editPageButtonProps = {
    children: t('Add a card'),
    className: 'button--success createReport',
    'data-col': 0,
    href: this.props.href,
    type: 'green',
    withIcon: true,
  };

  homepageButtonProps = {
    children: t('Edit Dashboard'),
    'data-col': 0,
    href: this.props.href,
    type: 'green',
    withIcon: false,
  };

  render() {
    const buttonProps = this.props.isHomepage
      ? this.homepageButtonProps
      : this.editPageButtonProps;

    return (
      <div className={'clearfix IntroCard--horizontal'}>
        <div
          style={{
            backgroundImage: `url(${getIntroCardImageSrc(
              'Dashboard-cards.svg',
            )})`,
          }}
        />
        <h3>{t('Get Started')}</h3>
        <p>{t('Assemble data-driven cards to create a dashboard.')}</p>
        <Button {...buttonProps} />
      </div>
    );
  }
}
